/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useState, useEffect, useRef} from 'react'
import axios from 'axios'
import {KTSVG} from '../_metronic/helpers'
import {getFileType} from './commonData'

const API_URL = process.env.REACT_APP_API_URL

type Props = {
  fileName: string
  documentCode: string
  osiCode: string
}

const OSIDocumentViewModal: React.FC<Props> = ({fileName, documentCode, osiCode}) => {
  const [resolvedUrl, setResolvedUrl] = useState<string>('')
  const blobUrlRef = useRef<string | null>(null)

  useEffect(() => {
    return () => {
      if (blobUrlRef.current) {
        URL.revokeObjectURL(blobUrlRef.current)
      }
    }
  }, [])

  useEffect(() => {
    if (fileName?.startsWith('s3://')) {
      axios
        .post(`${API_URL}/files/signed-url`, {filePath: fileName})
        .then((res) => setResolvedUrl(res.data?.signedUrl || ''))
        .catch(() => setResolvedUrl(''))
    } else {
      const legacyUrl = process.env.REACT_APP_IMG_URL + '/files/' + osiCode + '/' + fileName
      if (getFileType(fileName) === 'pdf') {
        fetch(legacyUrl)
          .then((res) => res.blob())
          .then((blob) => {
            if (blobUrlRef.current) {
              URL.revokeObjectURL(blobUrlRef.current)
            }
            const blobUrl = URL.createObjectURL(blob)
            blobUrlRef.current = blobUrl
            setResolvedUrl(blobUrl)
          })
          .catch(() => setResolvedUrl(legacyUrl))
      } else {
        setResolvedUrl(legacyUrl)
      }
    }
  }, [fileName, osiCode])

  return (
    <>
      <div
        className='modal fade'
        tabIndex={1}
        id={`kt_modal_document_view_${documentCode}`}
        data-testid={`kt_modal_document_view_${documentCode}`}
      >
        <div className='modal-dialog '>
          <div className='modal-content'>
            <div className='modal-header py-2'>
              <h4 className='modal-title'>View Document</h4>
              <div
                className='btn btn-icon btn-sm btn-active-light-primary ms-2'
                data-bs-dismiss='modal'
                aria-label='Close'
              >
                <KTSVG
                  path='/media/icons/duotune/arrows/arr061.svg'
                  className='svg-icon svg-icon-2x'
                />
              </div>
            </div>
            <div className=' w-100 position-relative text-center '>
              {getFileType(fileName) === 'pdf' ? (
                <iframe
                  title='Document View Frame'
                  src={resolvedUrl}
                  frameBorder='0'
                  width={'100%'}
                  height={'700px'}
                />
              ) : (
                <img
                  src={resolvedUrl}
                  alt='document'
                  className='w-100 h-auto'
                />
              )}
            </div>
          </div>
        </div>
      </div>
      <a
        type='button'
        role='button'
        className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
        data-bs-toggle='modal'
        data-bs-target={`#kt_modal_document_view_${documentCode}`}
        aria-label='View Document'
      >
        <i className='bi bi-eye-fill'></i>
      </a>
    </>
  )
}

export {OSIDocumentViewModal}
